import { useCallback, useContext } from 'react';
import { PersonalDataContext } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/tabs/personal-data/provider';

export const usePersonalData = () => {
    const { data, setData } = useContext(PersonalDataContext);

    const reset = useCallback(() => {
        setData(undefined);
    }, [setData]);

    return { reset, setData, data };
};
